import { gateNonstandardDateToDate } from "../../../sg-core";
import IFormDefinition from "./IFormDefinition";
import IObservation from "./IObservation";
import IPerson from "./IPerson";





interface IKnownObservationEventFormData { };
export type IObservationEventFormData = { [key: string]: any } & IKnownObservationEventFormData;


export interface IStandardEvent {
    id: number;
    title: string;
    type?: string;
    description?: string
    observation?: IObservation["id"];

    timestamp?: Date | null;
    performer?: IPerson["id"];

    historyPackageId?: string;
    pdfGuid?: string;

    formData?: IObservationEventFormData;
    formSchema?: IFormDefinition["schema"];

    ruleId?: string

    creator?: number


}

export type IObservationEvent = IStandardEvent

export type TCreatePermitEvent = Partial<Omit<IObservationEvent, "id" | "timestamp">>



export interface IObservationEventDTO {
    id: number;
    otsikko?: string;
    tyyppi?: string;
    kuvaus?: string
    lupa?: IObservation["id"];

    aikaleima?: string;
    suorittaja?: { id: number, sukunimi: string, etunimi: string }


    historiapaketti_id?: string;
    historia_pdf_guid?: string;


    creator?: number

}




export type TCreateObservationEvent = Partial<Omit<IObservationEvent, "id" | "timestamp">>
export type TCreateObservationEventDTO = Omit<IObservationEventDTO, "id" | "aikaleima">


export const ObservationEventMapper = {
    apiToDomain: (api: IObservationEventDTO): IObservationEvent => {

        const domain = {
            id: api.id,
            title: api.otsikko || "",
            description: api.kuvaus,
            type: api.tyyppi,
            permit: api.lupa,

            pdfGuid: api.historia_pdf_guid,
            historyPackageId: api.historiapaketti_id,


            timestamp: api.aikaleima ? gateNonstandardDateToDate(api.aikaleima) : undefined,

            performer: api.suorittaja?.id,

            creator: api.creator,
        }

        return domain
    },

    domainToApi: (domain: IObservationEvent): IObservationEventDTO => {

        const api = {
            id: domain.id,
            otsikko: domain.title,
            tyyppi: domain.type,
            kuvaus: domain.description,
            havainto: domain.observation,
            aikaleima: domain.timestamp?.toISOString(),
            historiapaketti_id: domain.historyPackageId,
            historia_pdf_guid: domain.pdfGuid,
            creator: domain.id,
        }

        return api


    },

    domainToCreatableApi: (domain: TCreateObservationEvent): TCreateObservationEventDTO => {
        const api = {
            otsikko: domain.title,
            kuvaus: domain.description,
            havainto: domain.observation,
            historiapaketti_id: domain.historyPackageId,
            historia_pdf_guid: domain.pdfGuid,
            tyyppi: domain.type,
        }

        return api
    },


}